import FeatherIconContainer from "../../Componant/Icons/FeatherIcon";

const FeatherIcons = () => {
  return (
    <div className="page-body">
      <FeatherIconContainer />
    </div>
  );
};

export default FeatherIcons;
